import React, { Component } from "react";
import {
  FormControl,
  Grid,
  TextField,
  Button,
} from "@material-ui/core";
import EmailIcon from '@material-ui/icons/Email';
import PhoneIcon from '@material-ui/icons/Phone';
import Typography from "@material-ui/core/Typography";
import formValidation from "../services/formValidation";

const inicialState = {
  nome: "",
  email: "",
  assunto: "",
  mensagem: "",
  errors: [],
};

export default class Contato extends Component {
  state = inicialState;
  constructor() {
    super();
    this.validator = new formValidation();
  }
  
  handleOnChange = (event) => {
    const valor = event.target.value;
    const nomeCampo = event.target.name;
    this.setState({
      [nomeCampo]: valor,
    });
  };

  handleSubmit = event => {
    try{
      event.preventDefault();
      const data = {
        nome: this.state.nome,
        email: this.state.email,
        assunto: this.state.assunto,
        mensagem: this.state.mensagem,
      }
      this.validator.validate(data);
      this.handleCleanInput();
    }catch (error) {
      const errors = error.errors;
      this.setState({
        errors: errors
      });
    }
  }

  handleCleanInput = () => {
    this.setState(inicialState);
  };

  render() {
return (
  <>
    <div className="contact-page">
      <header className="portfolio-section-header contact-header">
        <span className="portfolio-section-label">Contato profissional</span>

        <Typography
          gutterBottom
          variant="h4"
          component="h2"
        >
          Vamos conversar?
        </Typography>

        <p className="portfolio-section-description">
          Entre em contato para oportunidades, projetos, manutenção de sistemas,
          desenvolvimento web ou parcerias profissionais.
        </p>
      </header>

      {this.state.errors && this.state.errors.length > 0 && (
        <Grid container spacing={1} className="mt-4 grid-error">
          {this.state.errors.map((msg, index) => {
            return (
              <Grid item xs={12} key={index}>
                {msg}
              </Grid>
            );
          })}
        </Grid>
      )}

      <form autoComplete="off" className="contact-form-wrapper">
        <Grid container spacing={4} className="contact-grid">
          <Grid item xs={12} md={7}>
            <div className="contact-form-card">
              <FormControl fullWidth>
                <TextField
                  id="nome"
                  label="Nome"
                  variant="outlined"
                  aria-describedby="Name Field"
                  value={this.state.nome}
                  name="nome"
                  onChange={this.handleOnChange}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id="email"
                  label="E-mail"
                  variant="outlined"
                  aria-describedby="Email field"
                  className="my-3"
                  value={this.state.email}
                  name="email"
                  onChange={this.handleOnChange}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id="assunto"
                  label="Assunto"
                  variant="outlined"
                  aria-describedby="Assunto Field"
                  value={this.state.assunto}
                  name="assunto"
                  onChange={this.handleOnChange}
                />
              </FormControl>

              <FormControl fullWidth>
                <TextField
                  id="mensagem"
                  placeholder="Digite aqui a sua mensagem"
                  label="Mensagem"
                  variant="outlined"
                  multiline
                  margin="normal"
                  rows={6}
                  className="input-msg"
                  value={this.state.mensagem}
                  name="mensagem"
                  onChange={this.handleOnChange}
                />
              </FormControl>

              <FormControl fullWidth>
                <div className="contact-actions">
                  <Button
                    variant="outlined"
                    className="btn-clean"
                    color="primary"
                    onClick={this.handleCleanInput}
                  >
                    Limpar
                  </Button>

                  <Button
                    variant="contained"
                    className="btn-send"
                    color="primary"
                    onClick={this.handleSubmit}
                  >
                    Enviar mensagem
                  </Button>
                </div>
              </FormControl>
            </div>
          </Grid>

          <Grid item xs={12} md={5}>
            <aside className="contact-info-card">
              <span className="contact-info-label">Disponível para contato</span>

              <h3>Contato direto</h3>

              <p>
                Fique à vontade para me chamar por e-mail ou WhatsApp.
                Respondo assim que possível.
              </p>

              <div className="contact-info-list">
                <a
                  className="contact-info-item"
                  href="mailto:contato@rmsites.com.br"
                >
                  <span className="contact-icon">
                    <EmailIcon />
                  </span>
                  <span>contato@rmsites.com.br</span>
                </a>

                <a
                  className="contact-info-item"
                  href="https://wa.me/5513991851159"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <span className="contact-icon">
                    <PhoneIcon />
                  </span>
                  <span>(13) 99185-1159</span>
                </a>
              </div>
            </aside>
          </Grid>
        </Grid>
      </form>
    </div>
  </>
);
  }
}
